var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{staticClass:"w-100 br-20",attrs:{"placeholder":"Buscar producto"},on:{"input":_vm.buscarProductos},model:{value:(_vm.buscar),callback:function ($$v) {_vm.buscar=$$v},expression:"buscar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }